import { NativeSelect } from "@mui/material";
import React, { CSSProperties } from "react";
import { options } from "./const";
import { Styled } from "./styles";
// TODO: Add Globe icon to @aidergroup/ui-v2
import LanguageIcon from "@mui/icons-material/Language";
import useLocale from "@/context/locale";

interface Props {
    color?: "white" | "black";
    style?: CSSProperties;
}

const LanguagePicker: React.FC<Props> = ({ color = "black", style }) => {
    const { locale, setLocale } = useLocale();

    return (
        <Styled.Container style={style}>
            <LanguageIcon fontSize="medium" sx={{ color }} />
            <NativeSelect
                defaultValue={locale}
                inputProps={{
                    name: "locale",
                    id: "uncontrolled-native",
                }}
                onChange={e => {
                    setLocale(e.target.value as "sv" | "en");
                }}
                sx={{
                    "&:after, &:before": { display: "none" },
                    width: 120,
                }}
            >
                {options.map(({ id, value, name }) => {
                    return (
                        <option key={id} value={value}>
                            {name}
                        </option>
                    );
                })}
            </NativeSelect>
        </Styled.Container>
    );
};

export default LanguagePicker;
